// Results video script
const seeResultsWrapper = document.querySelector('.results-tabs-wrapper');
if(seeResultsWrapper) {
const seeResultsContent = seeResultsWrapper.querySelectorAll(
  '.results-video-container'
);
const seeResultsNav = seeResultsWrapper.querySelectorAll('.results-nav-item');
const baVideos = seeResultsWrapper.querySelectorAll('.results-video');
}
const showResults = (results) => {
  seeResultsContent.forEach((content, index) => {
    const resultsData = content.getAttribute('data-tab');
    if (resultsData === results) {
      content.classList.add('active');
    } else {
      content.classList.remove('active');
    }
  });
};

const removeActive = () => {
  seeResultsNav.forEach((navItem) => {
    navItem.classList.remove('active');
  });
};

document.addEventListener('DOMContentLoaded', function () {
 
  const switchActiveVideo = () => {
    baVideos.forEach((video) => video.classList.remove('active'));
  };

  const pauseAllVideos = () => {
    baVideos.forEach((video) => {
      video.pause();
    });
  };
  const handlePlayPause = (event) => {
    const videoElement = event.target;
    if (videoElement.paused) {
      pauseAllVideos();
      videoElement.play();
    } else if (videoElement.playing) {
      pauseAllVideos();
    }
  };

  const handleVideoEnded = (video) => {
    switchActiveVideo();
    video.classList.remove('active');
    const nextVideo = video.nextElementSibling;
    if (nextVideo && nextVideo.tagName === 'VIDEO') {
      nextVideo.classList.add('active');
      nextVideo.play();
    }
  };
  
  const handleVideoPlay = (event) => {
    switchActiveVideo();
    event.target.classList.add('active');
  };
  if(baVideos){ 
      baVideos.forEach((video) => {
        video.addEventListener('play', handleVideoPlay);
        video.addEventListener('click', handlePlayPause);
        video.addEventListener('ended', () => handleVideoEnded(video));
      });
    }

  const showResults = (results) => {
    seeResultsContent.forEach((content) => {
      const resultsData = content.getAttribute('data-tab');
      if (resultsData === results) {
        content.classList.add('active');
        const firstVideo = content.querySelector('video');
        if (firstVideo) {
          firstVideo.play();
        }
      } else {
        content.classList.remove('active');
      }
    });
  };

  const removeActiveNav = () => {
    seeResultsNav.forEach((navItem) => {
      navItem.classList.remove('active');
    });
  };

  seeResultsNav.forEach((navItem) => {
    const resultsData = navItem.getAttribute('data-tab');
    navItem.addEventListener('click', (event) => {
      const activeItem = event.currentTarget;
      removeActiveNav();
      navItem.classList.add('active');
      pauseAllVideos();
      showResults(resultsData);
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const sideCart = document.querySelector('#site-cart-sidebar');
  if (!sideCart) return;

  // Use delegation to handle clicks on any button inside sideCart
  sideCart.addEventListener('click', (e) => {
    const btn = e.target.closest('.cart-upsell-btn');
    if (btn) {
      addCartRecToCart(btn.dataset.variantId, 1);
    }
  });
});
  
  async function addCartRecToCart(variantId, quantity) {
	const data = { id: variantId, quantity };
	try {
	  const response = await fetch('/cart/add.js', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(data)
	  });
	  await response.json();
	  window.refreshCart();
	} catch (error) {
	  console.error(error);
	}
}

